var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-header-exit",attrs:{"title":"Выйти"},on:{"click":_vm.logout}},[_c('i',{staticClass:"mag-icon-nav-top-exit"})])
}
var staticRenderFns = []

export { render, staticRenderFns }